import { isAfter, addDays, endOfDay } from 'date-fns';

/**
 * Currently Kaluza cannot process COT move ins that are more than 7
 * days in the future.
 *
 * So this function will return a value of true of the move in is a COT
 * move in and the move date is more than 7 days in the future.
 */
export function isCotMoveInTooFarInTheFuture(isCot: boolean, moveDate: Date) {
  return isCot && isAfter(moveDate, addDays(endOfDay(new Date()), 7));
}
